// Dependencies
import { useState } from 'react';
import { Route, Switch } from 'react-router-dom';

// Components
import OrderDetailMX from '../OrderDetailMx';
import Address from '../Address';
import Checkout from '../Checkout';
import HeaderMX from '../OrderMXHeader';
import SessionMessage from '../SessionMessage';
import getCookie from '../Queries/getCookie';

// Styles
import styles from './index.module.sass';

export default function OrderMX({ history, match, webservice, device, screenSize }) {
  const [sessionMessage, setSessionMessage] = useState('');

  return (
    <div className={`${styles.order} ${styles[screenSize]}`}>
      <SessionMessage sessionMessage={sessionMessage} history={history} />
      <HeaderMX
        getCookie={getCookie}
        history={history}
        match={match}
        setSessionMessage={setSessionMessage}
      />

      <div className={styles.orderHeader}>
        <div
          className={styles.return}
          onClick={(e) => {
            history.push('cart/consultancy/home/');
          }}>
          <i className='material-icons-outlined'>navigate_before</i>
          <span className={styles.returnText}>Regresar</span>
        </div>
      </div>

      <Switch>
        <Route
          path={`${match.path}/addressdetail`}
          render={(props) => {
            return (
              <Address
                {...props}
                device={device}
                history={history}
                webservice={webservice}
                getCookie={getCookie}
                setSessionMessage={setSessionMessage}
              />
            );
          }}
        />
        <Route
          path={`${match.path}/checkout/:hostedTransactionIdentifier`}
          render={(props) => {
            return (
              <Checkout
                {...props}
                device={device}
                history={history}
                webservice={webservice}
                getCookie={getCookie}
                setSessionMessage={setSessionMessage}
              />
            );
          }}
        />
        <Route
          exact
          path={`${match.path}/:orderMessage?`}
          render={(props) => {
            return (
              <OrderDetailMX
                history={history}
                match={match}
                getCookie={getCookie}
                webservice={webservice}
                device={device}
                setSessionMessage={setSessionMessage}
              />
            );
          }}
        />
      </Switch>
    </div>
  );
}
